export const RESULT_MAPPING_KEY = 'perspective.result-mapping.';
export const TRACKING_KEY = 'perspective.tracking-preferences.';
export const TRACKING_PROPERTIES_KEY = 'perspective.tracking-properties.';
export const SPLIT_TESTING_KEY = 'perspective.split-testing-variant.';
export const USER_ID_KEY = 'perspective__user__id';
export const COLOR_LIGHT = '#F5F5F5';
export const COLOR_DARK = '#2A2A2A';
export const TRANSITION_DELAY = 100;
export const OTP_COOLDOWN = 25; // in seconds
export const OTP_VERIFICATION_DELAY = 2000; // in milliseconds
export const OTP_CONSECUTIVE_DELAY = 500; // in milliseconds
export const EXTERNAL_REDIRECT_TIMEOUT = 400; // in milliseconds

export const PREVIEW_MODE = import.meta.env.VITE_PREVIEW_MODE === 'true';
export const PREVIEW_CONTAINER_ID = 'perspective-frame-container';
export const PREVIEW_FRAME_ROOT = 'perspective-frame-root';
export const DISABLED_IN_PREVIEW = 'disabled_in_preview';
